'use strict'

export let norwegian_noProject={
  background: {
    fields: {
      background: {
        title:"Hvorfor ble aktiviteten startet?",
        help:`Hva er virksomhetenes behov denne aktviteten skal adressere?
          Hvilket problemet prøver å løse?
          Hvordan vet vi at det er et problem?
          Hvem løser vi problemet for, og hvordan vet vi at de ønsker å få løst dette udekkede behovet?`,
        description:"Begrunnelse for aktiviteten"
      },
      bigPicture: {
        title: "I hvilken sammeheng utføres aktiviteten?",
        help:`Er denne aktiviteten del av et større strategisk initiativ?
          Hvordan er det knyttet til bedriftsstrategien?`,
        description:"Beskriv hvordan aktiviteten er knyttet til strategier og inititativ på et høyere nivå"
      }
    }
  },
  objectives: {
    fields: {
      benefitsDescription: {
        help:`Hvilke målbare forbedringer vil denne aktiviteten lede til?
          Hvilke gevinster er mer eller mindre vitkige?`,
        description:"De forventede forbedringene denne aktiviteten vil føre til"
      },
      objectives: {
        description:"Annen relevant informasjon relatert til resultatmålene for denne aktiviteten"
      }

    }
  },
  scope: {
    fields: {
      projectScope: {
        help: undefined
      },
      scopeExclusions: {
        helt:undefined,
        description:"Beskriv hva som ikke inngår i aktiviteten."
      },
      outcomes: {
        help: `Hvordan vil aktiviteten gjøre det mulig for organisasjonen å betjene sine kunder eller brukere bedre? Hvilke nye ting (evne) kan våre kunder (intern og ekstern) gjøre når aktiviteten er utført?`
      }
    }
  },
  constraints: {
    fields: {
      constraints: {
        help:undefined,
        description:"Restriksjoner eller begrensninger for aktiviteten"
      }
    }
  },
  stakeholders: {
    fields: {
      stakeholders: {
        help:undefined
      },
      interfaces: {
        help:undefined,
        description: "Beskriv grensesnitt for aktiviteten"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./views/definition/labels/norwegian#noProject.js